import { FormInputsProps } from "../V2/types/formTypes";

export function print_when_component_is_rendered(component: FormInputsProps) {
    if (process.env.NODE_ENV === "development") {
        console.log(`${component.key} rendered`, component.full_path, { component });
    }
}
